import { createHash } from '../hash';
/**
 * Check for valid email format
 * @param value email
 */
export const _isValidPlaintextEmail = (value) => {
    if (typeof value !== 'string') {
        return false;
    }
    // simple email format
    const format = /^.+@.+\..+$/;
    return !!value.match(format);
};
/**
 * Creates hash from plaintext email. If email format is invalid, returns empty string
 * @param value
 */
export const createEmailHash = (value) => _isValidPlaintextEmail(value) ? createHash(value.toLowerCase()) : '';
